<template>
  <div class="chinese-drug-wrapper">
    <div class="chinese-drugs">{{ drugs }}</div>
    <div class="chinese-usage-wrapper">
      <div class="chinese-title">用法用量</div>
      <div class="chinese-item">
        共{{ chineseDrugModel.dose }}剂，每日{{ chineseDrugModel.dosePerDay }}剂，每剂分{{
          chineseDrugModel.countPerDose
        }}次使用
      </div>
      <div class="chinese-item">用药方式：{{ chineseDrugModel.drugUsage }}</div>
      <div class="chinese-item">用药时间：{{ chineseDrugModel.drugTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChineseDrug',
  props: {
    drugList: {
      type: Array,
      default: () => []
    },
    chineseDrugModel: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    drugs() {
      return this.drugList.map(drug => `${drug.name} ${drug.num}${drug.unit}`).join('，');
    }
  }
};
</script>

<style scoped lang="scss">
.chinese-drug-wrapper {
  .chinese-drugs {
    margin-bottom: 12pt;
    font-size: 12pt;
    font-weight: 500;
    color: #000;
    line-height: 1.4;
  }

  .chinese-usage-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8pt;
    margin-bottom: 12pt;

    .chinese-title {
      font-size: 12pt;
      font-weight: 500;
      color: #000;
      line-height: 1.4;
    }

    .chinese-item {
      font-size: 10pt;
      color: #000;
      line-height: 1.4;
    }
  }
}
</style>
